module.exports = __webpack_public_path__ + "img/Hvac.c174752a.png";